import { DailyItem } from './dailyitem'

export const Sunday = new DailyItem({
  id: '5D436AD1-1C1D-4D50-B5DF-4A602F0DB2E3',
  name: 'sunday',
  label: 'Sunday',
  value: 0,
})
export const Monday = new DailyItem({
  id: 'F9E74DE6-7034-4182-B152-F6A3DD1028B3',
  name: 'monday',
  label: 'Monday',
  value: 1,
})
export const Tuesday = new DailyItem({
  id: 'C5F7DF82-E6B9-4DD0-8969-9CFCF989A1B9',
  name: 'tuesday',
  label: 'Tuesday',
  value: 2,
})
export const Wednesday = new DailyItem({
  id: '786D8F67-4AAE-471D-B7F5-BBD2B074BEAB',
  name: 'wednesday',
  label: 'Wednesday',
  value: 3,
})
export const Thursday = new DailyItem({
  id: '73A25B4B-DC3B-4AC2-9A81-64F3DECF38ED',
  name: 'thursday',
  label: 'Thursday',
  value: 4,
})
export const Friday = new DailyItem({
  id: 'F3CF8CB2-53CC-4438-A8DB-4F50087E15CD',
  name: 'friday',
  label: 'Friday',
  value: 5,
})
export const Saturday = new DailyItem({
  id: '6F7771F8-A820-4547-9EAA-75E1B5DD2C64',
  name: 'saturday',
  label: 'Saturday',
  value: 6,
})
